import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.css';
import App from './App.jsx';

// Add navigation debugging
if (typeof window !== 'undefined') {
  const originalPushState = window.history.pushState;
  const originalReplaceState = window.history.replaceState;

  window.history.pushState = function() {
    console.log('🛣️ Navigation pushState:', arguments[2]);
    return originalPushState.apply(this, arguments);
  };

  window.history.replaceState = function() {
    console.log('🛣️ Navigation replaceState:', arguments[2]);
    return originalReplaceState.apply(this, arguments);
  };
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
